import { api } from "./client";
import type { PortalNotificationType } from "./adminNotifications";

// External Collection → Notifications — the authenticated external user's
// portal feed. Read state is resolved server-side off the portal session,
// never a client-supplied id. Mirrors the /api/portal/notifications
// controller.

export interface PortalNotificationFeedItem {
  id: string;
  title: string;
  body: string;
  type: PortalNotificationType;
  createdAt: string;
  readAt: string | null;
}

export const portalNotificationsApi = {
  list: () => api.get<PortalNotificationFeedItem[]>("/portal/notifications"),
  unreadCount: () =>
    api.get<number>("/portal/notifications/unread-count"),
  markRead: (ids?: string[]) =>
    api.post<number>("/portal/notifications/mark-read", { ids: ids ?? null }),
};
